import { useMemo } from 'react';

import { EnumListKey, useAllEnums } from '~/data/enums';

import { EnumMap } from './resolveEmploymentTranslatedData';

const PERSONNEL_GROUP_KEYS = [
  EnumListKey.PERSONNEL_GROUP_1,
  EnumListKey.PERSONNEL_GROUP_2,
  EnumListKey.PERSONNEL_GROUP_3,
  EnumListKey.PERSONNEL_GROUP_4,
  EnumListKey.PERSONNEL_GROUP_5,
] as const;

export const usePersonnelGroupEnums = () => {
  const { getEnums } = useAllEnums();

  return useMemo(() => {
    const personnelGroupNames = getEnums(EnumListKey.PERSONNEL_GROUP_NAME);

    const personnelGroupEnumsByGroup: EnumMap = Object.fromEntries(
      PERSONNEL_GROUP_KEYS.map((key) => [key, getEnums(key)]),
    );

    return {
      personnelGroupNames,
      personnelGroupEnumsByGroup,
    };
  }, [getEnums]);
};
